module.exports = __webpack_public_path__ + "img/No_Record@2x.58a0d04a.png";